function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

var Logger = /*#__PURE__*/function () {
  function Logger() {}
  Logger.logPlugins = function logPlugins(pluginsNames) {
    console.log("Aboyeur Plugins initialized: " + pluginsNames.join(', '));
  };
  Logger.logEvent = function logEvent(plugins, eventOptions) {
    var entity = eventOptions.entity,
      feature = eventOptions.feature,
      label = eventOptions.label,
      metadata = eventOptions.metadata;
    console.groupCollapsed("Event: " + entity + " > " + String(feature) + " > " + label);
    console.groupCollapsed('Plugins');
    console.log(plugins.map(function (plugin) {
      return plugin.name;
    }).join(', '));
    console.groupEnd();
    var global = metadata.global,
      instance = metadata.instance,
      event = metadata.event;
    console.groupCollapsed('Global Metadata');
    console.table(global);
    console.groupEnd();
    console.groupCollapsed('Instance Metadata');
    console.table(instance);
    console.groupEnd();
    console.groupCollapsed('Event Metadata');
    console.table(event);
    console.groupEnd();
    console.groupEnd();
  };
  return Logger;
}();

function mapObjIndexed(fn, obj) {
  var newObj = {};
  for (var currentKey in obj) {
    var value = obj[currentKey];
    newObj[currentKey] = fn(value, currentKey, obj);
  }
  return newObj;
}

var ERRORS = {
  NO_PLUGINS: 'No plugins has been initialized'
};
var Aboyeur = /*#__PURE__*/function () {
  function Aboyeur(entity, featuresConfigs) {
    this.entity = entity;
    this.featuresConfigs = featuresConfigs;
    this.metadata = {};
    this.plugins = [];
  }
  Aboyeur.mock = function mock() {
    Aboyeur.isTest = true;
    Aboyeur.mocks = {
      initializePlugin: jest.fn(),
      sendEvent: jest.fn()
    };
  };
  Aboyeur.initialize = function initialize(metadata, rawPlugins, options) {
    if (options != null && options.isTest) {
      Aboyeur.mock();
    }
    if (options != null && options.dryRun) {
      Aboyeur.dryRun = true;
    }
    var initializedPlugins = Object.values(rawPlugins).map(function (Plugin) {
      var plugin = new Plugin().withMetadata(metadata);
      if (Aboyeur.isTest) {
        Aboyeur.mocks.initializePlugin == null ? void 0 : Aboyeur.mocks.initializePlugin(plugin.name);
      } else if (!Aboyeur.dryRun) {
        plugin.initialize();
        plugin.onMetadataChange();
      }
      return plugin;
    });
    Aboyeur.metadata = metadata;
    Aboyeur.plugins = initializedPlugins;
    if (Aboyeur.dryRun) {
      Logger.logPlugins(Aboyeur.getPluginsNames());
    }
  };
  Aboyeur.updateMetadata = function updateMetadata(metadata) {
    var plugins = Aboyeur.plugins;
    if (!plugins.length) {
      throw new Error(ERRORS.NO_PLUGINS);
    }
    if (typeof metadata === 'function') {
      Aboyeur.metadata = metadata(Aboyeur.metadata);
    } else {
      Aboyeur.metadata = metadata;
    }
    Aboyeur.plugins = plugins.map(function (plugin) {
      var updatedPlugin = plugin.withMetadata(Aboyeur.metadata);
      updatedPlugin.onMetadataChange();
      return updatedPlugin;
    });
  };
  Aboyeur.getPluginsNames = function getPluginsNames() {
    return Aboyeur.plugins.map(function (plugin) {
      return plugin.name;
    });
  };
  Aboyeur.cleanup = function cleanup() {
    Aboyeur.metadata = {};
    Aboyeur.plugins = [];
    Aboyeur.isTest = false;
    Aboyeur.dryRun = false;
  };
  var _proto = Aboyeur.prototype;
  _proto.buildFeatureEvent = function buildFeatureEvent(feature) {
    var initializedPlugins = Aboyeur.plugins;
    if (!initializedPlugins.length) {
      throw new Error(ERRORS.NO_PLUGINS);
    }
    var entity = this.entity;
    var instanceMetadata = this.metadata;
    var instancePluginsToFilter = this.plugins;
    return function sendEvent(_ref) {
      var label = _ref.label,
        metadata = _ref.metadata,
        _ref$plugins = _ref.plugins,
        plugins = _ref$plugins === void 0 ? [] : _ref$plugins;
      var eventPluginsToFilter = typeof plugins === 'function' ? plugins(Aboyeur.getPluginsNames()) : plugins;
      var pluginsToFilter = eventPluginsToFilter.length > 0 ? eventPluginsToFilter : instancePluginsToFilter;
      var filteredPlugins = initializedPlugins.filter(function (plugin) {
        if (pluginsToFilter.length > 0) {
          return pluginsToFilter.includes(plugin.name);
        }
        return plugin["default"];
      });
      var event = {
        label: label,
        entity: entity,
        feature: feature,
        metadata: {
          event: metadata || {},
          global: Aboyeur.metadata,
          instance: instanceMetadata
        }
      };
      if (Aboyeur.dryRun) {
        Logger.logEvent(filteredPlugins, event);
        return;
      }
      filteredPlugins.forEach(function (plugin) {
        if (Aboyeur.isTest) {
          Aboyeur.mocks.sendEvent == null ? void 0 : Aboyeur.mocks.sendEvent(plugin.name, event);
          return;
        }
        plugin.sendEvent(event);
      });
    };
  };
  _proto.withMetadata = function withMetadata(metadata) {
    if (typeof metadata === 'function') {
      this.metadata = metadata(this.metadata);
    } else {
      this.metadata = metadata;
    }
    return this;
  };
  _proto.withPlugins = function withPlugins(plugins) {
    if (typeof plugins === 'function') {
      this.plugins = plugins(Aboyeur.getPluginsNames());
    } else {
      this.plugins = plugins;
    }
    return this;
  };
  _createClass(Aboyeur, [{
    key: "events",
    get: function get() {
      var _this = this;
      var featuresConfigs = this.featuresConfigs;
      var events = mapObjIndexed(function (eventsConfig, feature) {
        var sendEvent = _this.buildFeatureEvent(feature);
        return mapObjIndexed(function (getEventsConfig) {
          return function () {
            var eventConfigs = getEventsConfig.apply(void 0, arguments);
            sendEvent(eventConfigs);
          };
        }, eventsConfig);
      }, featuresConfigs);
      return events;
    }
  }]);
  return Aboyeur;
}();
Aboyeur.isTest = false;
Aboyeur.dryRun = false;
Aboyeur.metadata = {};
Aboyeur.plugins = [];
Aboyeur.mocks = {};

var AboyeurPlugin = /*#__PURE__*/function () {
  function AboyeurPlugin() {
    this.name = AboyeurPlugin.displayName;
    /**
     * If true this plugin will be enabled as a default plugin
     */
    this["default"] = true;
    /**
     * Global Metadata to bootstrap this plugin
     */
    this.metadata = {};
  }
  /**
   * Global Metadata to bootstrap this plugin
   */
  var _proto = AboyeurPlugin.prototype;
  _proto.initialize = function initialize() {
    return;
  }
  /**
   * Main method to send event using your custom tool
   * @param _options
   */;
  _proto.sendEvent = function sendEvent(_options) {
    return;
  }
  /**
   * Callback to handle very Metadata Change
   */;
  _proto.onMetadataChange = function onMetadataChange() {
    return;
  };
  _proto.withMetadata = function withMetadata(metadata) {
    this.metadata = metadata;
    return this;
  };
  return AboyeurPlugin;
}();
/**
 * Name used to filter and reference this plugin
 */
AboyeurPlugin.displayName = 'AboyeurPlugin';
/**
 * You could use this helper to name your plugin accordingly
 * @param name
 * @returns A Custom AboyeurPlugin named with the parameter above
 * @example
 * class CustomPlugin extends AboyeurPluginNamed('MY_AWESOME_PLUGIN_NAME') {}
 */
function AboyeurPluginNamed(name) {
  var _a;
  return _a = /*#__PURE__*/function (_AboyeurPlugin) {
    _inheritsLoose(_a, _AboyeurPlugin);
    function _a() {
      var _this;
      _this = _AboyeurPlugin.apply(this, arguments) || this;
      _this.name = name;
      return _this;
    }
    return _a;
  }(AboyeurPlugin), _a.displayName = name, _a;
}

export { Aboyeur, AboyeurPlugin, AboyeurPluginNamed };
//# sourceMappingURL=aboyeur.esm.js.map
